import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import PregnancyCare from "@/pages/PregnancyCare";
import WomensHealth from "@/pages/WomensHealth";
import PatientExperience from "@/pages/PatientExperience";
import Contact from "@/pages/Contact";
import Appointment from "@/pages/Appointment";
import Privacy from "@/pages/Privacy";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Enquiries from "@/pages/admin/Enquiries";
import Appointments from "@/pages/admin/Appointments";
import AdminServices from "@/pages/admin/AdminServices";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSecurity from "@/pages/admin/AdminSecurity";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pregnancy-care" element={<PregnancyCare />} />
              <Route path="/womens-health" element={<WomensHealth />} />
              <Route path="/patient-experience" element={<PatientExperience />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/appointment" element={<Appointment />} />
              <Route path="/privacy" element={<Privacy />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="security" element={<AdminSecurity />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
